/* platform/rbac — Frontend role definitions and capability checks.
   Real enforcement is on the backend (PlatformGuard + SuperAdminGuard).
   Frontend RBAC gates UI only — do not rely on it for security. */

export const PLATFORM_ROLES = {
  SUPER_ADMIN:    { label: 'Super Admin',    tone: 'purple', order: 0 },
  PLATFORM_ADMIN: { label: 'Platform Admin', tone: 'blue',   order: 1 },
  SUPPORT:        { label: 'Support',        tone: 'green',  order: 2 },
  BILLING:        { label: 'Billing',        tone: 'amber',  order: 3 },
  AUDITOR:        { label: 'Auditor',        tone: 'gray',   order: 4 },
};

const CAPABILITIES = {
  SUPER_ADMIN:    ['*'],
  PLATFORM_ADMIN: ['read', 'write', 'invite', 'suspend', 'license', 'reset_password', 'delete'],
  SUPPORT:        ['read', 'reset_password'],
  BILLING:        ['read', 'license'],
  AUDITOR:        ['read'],
};

export const can = (platformRole, action) => {
  const role = (platformRole || '').toUpperCase().replace(/ /g, '_');
  const caps = CAPABILITIES[role];
  if (!caps) return false;
  if (caps[0] === '*') return true;
  return caps.includes(action);
};

export const getPlatformRole = () => {
  try {
    if (window.__nx_auth?.user?.platformRole) return window.__nx_auth.user.platformRole;
    const sess = JSON.parse(localStorage.getItem('nx-session-v1'));
    return sess?.platformRole || null;
  } catch (_) { return null; }
};

export const getRoleInfo = (role) =>
  PLATFORM_ROLES[(role || '').toUpperCase().replace(/ /g, '_')] || { label: role || 'Unknown', tone: 'gray', order: 99 };
